import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalService } from '../modal.service';

@Component({
  selector: 'app-modal-activity-user-register',
  templateUrl: './modal-activity-user-register.component.html',
  styleUrls: ['./modal-activity-user-register.component.scss']
})
export class ModalActivityUserRegisterComponent implements OnInit {

  @ViewChild('activityUserRegisterModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-md', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  
  items: any = [];
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.modalServ.onActivityUserRegister.subscribe(req => {
      this.items = req.items;
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onActivityUserRegisterHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  confirm(): void {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = false;
  }

}
